import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { AudioPlayerContext } from '../../../components/contexts/audio-player';
import recordPause from '../../../assets/svg/record_pause.svg';
import recordPlay from '../../../assets/svg/record_play.svg';
import config from '../../../settings/config.json';

function Home_Player() {
  const { isPlaying, togglePlay } = useContext(AudioPlayerContext);
  const [currentTrack, setCurrentTrack] = useState(null);

  useEffect(() => {
    const fetchCurrentTrack = async () => {
      try {
        const response = await axios.get(`/player/status`);
        const source = response.data.icestats.source;
        const track = Array.isArray(source) ? source[0].title : source.title;
        setCurrentTrack(track);
      } catch (error) {
        console.error('Ошибка при получении текущего трека:', error);
      }
    };

    fetchCurrentTrack();
    const interval = setInterval(fetchCurrentTrack, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='Player' id='home'>
      <br /><br /><br /><br /><br /><br />
      <div className='center-content qw-pc'>
        <img
          src={isPlaying ? recordPlay : recordPause}
          width='400px'
          className={`record ${isPlaying ? '' : 'spinning'}`}
          alt='Record'
          onClick={togglePlay}
        />
        <div className='texts'>
          <h1 className='title_gradient'>ZÖVQÜNÜZƏ <b className='text-gradient'>UYĞUN</b></h1>
          <br />
          <h1 className='title_radio'>RADIO FACE</h1>
          <h3 className='text-secondary font-reqular'>by. <span className='text-gradient'>Güldiyar Zülfüqar </span></h3>
          <br />
          <h2 className='current_track'><i className="fa-solid fa-music text-gradient"></i> {currentTrack}</h2>
        </div>
      </div>

      <div className='qw-mobile'>
        <center>
        <img
          src={isPlaying ? recordPlay : recordPause}
          width='300px'
          className={`record ${isPlaying ? '' : 'spinning'}`}
          alt='Record'
          onClick={togglePlay}
        />
        </center>
        <br /><br />
        <center>
          <h1 className='title_gradient-m'>ZÖVQÜNÜZƏ <b className='text-gradient'>UYĞUN</b></h1>
          <br />
          <h1 className='title_radio-m'>RADIO FACE</h1>
          <h5 className='text-secondary font-reqular'>by. <span className='text-gradient'>Güldiyar Zülfüqar </span></h5>
          <br />
          <h2 className='current_track'><i className="fa-solid fa-music text-gradient"></i> {currentTrack}</h2>
        </center>
      </div>
    </div>
  );
}

export default Home_Player;